import { AgxTypography } from '@urbanx/agx.ui-components2'

interface TaskCampaignCellProps {
  propertyAddress?: string
  index: number
  isNew?: boolean
}

const TaskCampaignCell = ({
  propertyAddress,
  index,
  isNew,
}: TaskCampaignCellProps) => {
  return (
    <div className="taskCampaignCell">
      <AgxTypography
        id={`row-${index}-campaign`}
        size="small"
        color={isNew ? 'var(--text-primary)' : 'var(--text-secondary)'}
        type={isNew ? 'body_ui_strong' : 'body_ui'}
      >
        {propertyAddress}
      </AgxTypography>
    </div>
  )
}

export default TaskCampaignCell
